<template>
  <div class="app">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>

  <ClientOnly>
    <ModalContainer />
    <CookieBanner agreement-link="/soglasie-na-obrabotku-personalnyx-dannyx/" />
    <AuthPush />
  </ClientOnly>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, hydrateOnIdle } from 'vue';
  import ModalContainer from '@devhacker/shared/plugins/modal/ModalContainer.vue';
  import { useUserStore } from '~/features/user/store';
  import { useAdfoxWindowAssign } from '~/composables/useAdfoxWindowAssign';
  import { useWindowTracking } from '~/composables/window';

  const CookieBanner = defineAsyncComponent({
    loader: () => import('@devhacker/shared/components/CookieBanner.vue'),
    hydrate: hydrateOnIdle(),
  });

  const AuthPush = defineAsyncComponent({
    loader: () => import('~/components/AuthPush.vue'),
    hydrate: hydrateOnIdle(),
  });

  useAdfoxWindowAssign();
  useWindowTracking();

  useHead({
    script: [
      {
        // скрипты асинхронные, поэтому нужно создать массимы/объекты под них
        // обычно достаточно window.yaContextCb = window.yaContextCb || []
        // но у нас реклама что внутри статей использует внутри adfoxCode.hbCallbacks
        // поэтому мы ее так-же добавляем, согласно документации
        // хоть у нас и не бесконечный скрол, но действия нужны те-же
        // https://yandex.ru/support2/adfox/ru/monetization/script-features#endless-scroll
        tagPriority: -50,
        innerHTML:
          'window.yaContextCb = window.yaContextCb || [];\n' +
          'window.Ya || (window.Ya = {});\n' +
          'window.Ya.adfoxCode || (window.Ya.adfoxCode = {});\n' +
          'window.Ya.adfoxCode.hbCallbacks || (window.Ya.adfoxCode.hbCallbacks = []);',
      },
      {
        // https://yandex.ru/support/adfox-sites/monetization/hb-change-code.html
        tagPriority: -49,
        src: 'https://yandex.ru/ads/system/header-bidding.js',
        async: true,
      },
      {
        // https://yandex.ru/support/partner/web/products-rtb/partner-code.html
        tagPriority: -48,
        src: 'https://yandex.ru/ads/system/context.js',
        crossorigin: 'anonymous',
        async: true,
      },
    ],
  });

  onMounted(async () => {
    const { $api, $logger } = useNuxtApp();
    const userStore = useUserStore();
    try {
      const res = await $api.wordPress.fetchIsLoggedIn();
      userStore.setIsLoggedInWp(res?.logged ?? false);
    } catch (error) {
      $logger.error('fetchIsLoggedIn', error);
    }
  });
</script>

<style lang="scss">
  @use '../node_modules/@devhacker/shared/utils/dom/scrollLock.scss';
</style>

<style lang="scss">
  @view-transition {
    navigation: auto;
  }

  :root {
    --header-height: 100px;
  }
</style>
